import React, { useEffect, useState } from "react";
import API from "../services/api";

const PendingDrivers = () => {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Modal State
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [vehicleTypeFilter, setVehicleTypeFilter] = useState("");

  // =========================
  // FETCH PENDING DRIVERS
  // =========================
  const fetchPendingDrivers = async () => {
    try {
      setLoading(true);

      const res = await API.get("/pending-drivers");

      if (res.data.success) {
        setDrivers(res.data.drivers);
      }

    } catch (err) {

      setError(
        err.response?.data?.message || "Failed to load drivers"
      );

    } finally {

      setLoading(false);

    }
  };

  // =========================
  // OPEN REVIEW MODAL
  // =========================
  const handleOpenReview = async (id) => {
    try {

      const res = await API.get(`/driver/${id}`);

      if (res.data.success) {

        setSelectedDriver(res.data.driver);
        setIsModalOpen(true);

      }

    } catch (err) {

      alert("Error fetching driver details");

    }
  };

  // =========================
  // UPDATE DOC STATUS
  // =========================
  const handleUpdateStatus = async (docType, status) => {

    let reason = "";

    if (status === "rejected") {

      reason = prompt("Enter rejection reason:");

      if (!reason) return;

    }

    try {

      setUpdating(true);

      const res = await API.put(
        `/driver/document-status/${selectedDriver._id}`,
        {
          documentType: docType,
          status,
          rejectionReason: reason
        }
      );

      if (res.data.success) {

        setSelectedDriver((prev) => ({
          ...prev,
          documents: res.data.documents,
          overallApprovalStatus:
            res.data.overallApprovalStatus || prev.overallApprovalStatus
        }));

        fetchPendingDrivers();

        alert(`Document ${status} successfully`);

      }

    } catch (err) {

      alert(err.response?.data?.message || "Update failed");

    } finally {

      setUpdating(false);

    }
  };

  useEffect(() => {
    fetchPendingDrivers();
  }, []);

      const filteredDrivers = drivers.filter((d) => {
    const matchesName = d.name?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesVehicle = vehicleTypeFilter
      ? d.vehicleDetails?.type === vehicleTypeFilter
      : true;
    return matchesName && matchesVehicle;
  });


  if (loading && drivers.length === 0) {
    return (
      <div style={styles.loading}>
        Loading Pending Drivers...
      </div>
    );
  }

  return (
    <div style={styles.page}>

      {/* HEADER */}
      <div style={styles.header}>

        <div>
          <h2 style={styles.title}>
            Pending Driver Approvals
          </h2>

          <p style={styles.subtitle}>
            Review uploaded documents and verify drivers
          </p>
        </div>

        {/*<div style={styles.badgeCount}>
          {drivers.length} Pending
        </div>

      </div>*/}


            <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <input
            type="text"
            placeholder="Search by name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={styles.searchInput}
          />
          <select
            style={styles.searchInput}
            value={vehicleTypeFilter}
            onChange={(e) => setVehicleTypeFilter(e.target.value)}
          >
            <option value="">All Vehicle Types</option>
            <option value="bike">Bike</option>
            <option value="ape">3 Wheeler (Ape)</option>
            <option value="pickup">Pickup / Mini Truck</option>
            <option value="truck">Truck</option>
          </select>
          <div style={styles.badgeCount}>
            {filteredDrivers.length} Pending
          </div>
        </div>

      </div>


      {error && (
        <div style={styles.error}>
          {error}
        </div>
      )}

      {/* GRID */}
      <div style={styles.grid}>

        {filteredDrivers.map((d) => (

          <div key={d._id} style={styles.card}>

            <div style={styles.cardTop}>

              <span style={styles.driverId}>
                #{d._id.slice(-6).toUpperCase()}
              </span>

              <span style={styles.statusBadge}>
                {d.overallApprovalStatus}
              </span>

            </div>

            <h3 style={styles.driverName}>
              {d.name}
            </h3>

            <p style={styles.contactInfo}>
              {d.phone}
            </p>

            <div style={styles.vehicleBox}>

              <div style={styles.label}>
                Vehicle Details
              </div>

              <div style={styles.vehicleText}>
                <strong>
                  {d.vehicleDetails?.model || "N/A"}
                </strong>{" "}
                ({d.vehicleDetails?.type || "N/A"})
              </div>

              <div style={styles.plateNumber}>
                {d.vehicleDetails?.number || "N/A"}
              </div>

            </div>

            <button
              style={styles.reviewBtn}
              onClick={() => handleOpenReview(d._id)}
            >
              Review Documents
            </button>

          </div>

        ))}

      </div>

      {/* MODAL */}
      {isModalOpen && selectedDriver && (

        <div
          style={styles.overlay}
          onClick={() => setIsModalOpen(false)}
        >

          <div
            style={styles.modal}
            onClick={(e) => e.stopPropagation()}
          >

            <div style={styles.modalHeader}>

              <div>

                <h3 style={styles.modalTitle}>
                  {selectedDriver.name}
                </h3>

                <div style={{
                  display: "flex",
                  gap: "10px",
                  marginTop: "5px"
                }}>

                  <span style={styles.modalSubtitle}>
                    ID: {selectedDriver._id.slice(-6)}
                  </span>

                  <span style={styles.statusBadge}>
                    {selectedDriver.overallApprovalStatus}
                  </span>

                </div>

              </div>

              <button
                style={styles.closeBtn}
                onClick={() => setIsModalOpen(false)}
              >
                ×
              </button>

            </div>

            <div style={styles.modalBody}>

              <h4 style={styles.sectionTitle}>
                Document Verification
              </h4>

              <div style={styles.docGrid}>

                {["license", "rc", "addharcard"].map((docKey) => {

                  const doc =
                    selectedDriver.documents?.[docKey];

                  return (

                    <div
                      key={docKey}
                      style={styles.docCard}
                    >

                      <div style={{
                        display: "flex",
                        justifyContent: "space-between"
                      }}>

                        <p style={styles.docLabel}>
                          {docKey.toUpperCase()}
                        </p>

                        <span style={{
                          fontSize: "10px",
                          fontWeight: "700",
                          color:
                            doc?.status === "approved"
                              ? "#166534"
                              : doc?.status === "rejected"
                              ? "#991b1b"
                              : "#92400e"
                        }}>
                          {doc?.status || "Missing"}
                        </span>

                      </div>

                      {doc?.url ? (

                        <>

                          <a
                            href={doc.url}
                            target="_blank"
                            rel="noreferrer"
                            style={styles.docLink}
                          >
                            View Document
                          </a>

                          <div style={styles.previewContainer}>

                            {/* IMAGE */}
                            <img
                              src={doc.url}
                              alt={docKey}
                              style={styles.previewImage}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />

                          </div>

                          <div style={styles.actionRow}>

                            <button
                              disabled={
                                updating ||
                                doc.status === "approved"
                              }
                              onClick={() =>
                                handleUpdateStatus(
                                  docKey,
                                  "approved"
                                )
                              }
                              style={{
                                ...styles.actionBtn,
                                backgroundColor: "#dcfce7",
                                color: "#166534"
                              }}
                            >
                              Approve
                            </button>

                            <button
                              disabled={
                                updating ||
                                doc.status === "rejected"
                              }
                              onClick={() =>
                                handleUpdateStatus(
                                  docKey,
                                  "rejected"
                                )
                              }
                              style={{
                                ...styles.actionBtn,
                                backgroundColor: "#fee2e2",
                                color: "#991b1b"
                              }}
                            >
                              Reject
                            </button>

                          </div>

                        </>

                      ) : (

                        <p style={{
                          fontSize: "11px",
                          color: "#94a3b8"
                        }}>
                          No file uploaded
                        </p>

                      )}

                      {doc?.rejectionReason && (
                        <p style={styles.rejectionText}>
                          Reason: {doc.rejectionReason}
                        </p>
                      )}

                    </div>

                  );
                })}

              </div>

              {/* BANK DETAILS */}
              <div style={styles.bankSection}>

                <h4 style={styles.sectionTitle}>
                  Banking Details
                </h4>

                <div style={styles.bankGrid}>

                  <div>
                    <p style={styles.docLabel}>
                      UPI ID
                    </p>

                    <p style={styles.bankValue}>
                      {selectedDriver.upiId || "N/A"}
                    </p>
                  </div>

                  <div>
                    <p style={styles.docLabel}>
                      Account Number
                    </p>

                    <p style={styles.bankValue}>
                      {selectedDriver.bankaccountnumber || "N/A"}
                    </p>
                  </div>

                   <div>
                    <p style={styles.docLabel}>
                      IFSC CODE
                    </p>

                    <p style={styles.bankValue}>
                      {selectedDriver.ifscCode || "N/A"}
                    </p>
                  </div>

                   <div>
                    <p style={styles.docLabel}>
                      Bank Name
                    </p>

                    <p style={styles.bankValue}>
                      {selectedDriver.bankName || "N/A"}
                    </p>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      )}

    </div>
  );
};

/* =========================
   STYLES
========================= */

const styles = {
  page: {
    padding: "30px",
    background: "#f8fafc",
    minHeight: "100vh",
    fontFamily: "'Inter', sans-serif"
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBottom: "30px",
    flexWrap: "wrap",
    gap: "20px"
  },

  title: {
    margin: 0,
    fontSize: "28px",
    color: "#1e293b",
    fontWeight: "700"
  },

  subtitle: {
    margin: "5px 0 0 0",
    color: "#64748b",
    fontSize: "14px"
  },

  badgeCount: {
    background: "#f59e0b",
    color: "#fff",
    padding: "10px 18px",
    borderRadius: "8px",
    fontWeight: "600",
    fontSize: "14px"
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: "20px"
  },

  card: {
    background: "#fff",
    borderRadius: "16px",
    padding: "20px",
    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)"
  },

  cardTop: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "15px"
  },

  driverId: {
    fontSize: "12px",
    color: "#94a3b8",
    fontFamily: "monospace"
  },

    searchInput: {
    padding: "10px 15px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    outline: "none",
    fontSize: "14px",
    background: "#fff",
    minWidth: "220px"
  },

  statusBadge: {
    background: "#fef3c7",
    color: "#92400e",
    padding: "4px 10px",
    borderRadius: "6px",
    fontSize: "11px",
    fontWeight: "800"
  },

  driverName: {
    margin: "0 0 4px 0",
    fontSize: "18px"
  },

  contactInfo: {
    marginBottom: "15px",
    color: "#64748b"
  },

  vehicleBox: {
    background: "#f8fafc",
    padding: "12px",
    borderRadius: "10px",
    marginBottom: "15px"
  },

  label: {
    fontSize: "11px",
    color: "#94a3b8",
    fontWeight: "700"
  },

  vehicleText: {
    fontSize: "14px"
  },

  plateNumber: {
    fontSize: "13px",
    color: "#64748b"
  },

  reviewBtn: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "none",
    background: "#3b82f6",
    color: "#fff",
    cursor: "pointer",
    fontWeight: "600"
  },

  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(15, 23, 42, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000
  },

  modal: {
    background: "#fff",
    width: "95%",
    maxWidth: "700px",
    borderRadius: "24px",
    padding: "30px",
    maxHeight: "90vh",
    overflowY: "auto"
  },

  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px"
  },

  modalTitle: {
    margin: 0,
    fontSize: "22px"
  },

  modalSubtitle: {
    fontSize: "12px",
    color: "#94a3b8"
  },

  closeBtn: {
    border: "none",
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    cursor: "pointer",
    fontSize: "22px"
  },

  modalBody: {
    marginTop: "10px"
  },

  sectionTitle: {
    fontSize: "13px",
    color: "#64748b",
    fontWeight: "700",
    marginBottom: "15px"
  },

  docGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "15px",
    marginBottom: "25px"
  },

  docCard: {
    padding: "15px",
    borderRadius: "12px",
    border: "1px solid #e2e8f0"
  },

  docLabel: {
    fontSize: "11px",
    color: "#94a3b8",
    fontWeight: "700",
    margin: 0
  },

  docLink: {
    display: "block",
    color: "#3b82f6",
    fontSize: "12px",
    margin: "10px 0",
    fontWeight: "600"
  },

  previewContainer: {
    width: "100%",
    height: "180px",
    borderRadius: "10px",
    overflow: "hidden",
    background: "#f1f5f9",
    marginTop: "10px",
    border: "1px solid #e2e8f0"
  },

  previewImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },

  actionRow: {
    display: "flex",
    gap: "8px",
    marginTop: "10px"
  },

  actionBtn: {
    flex: 1,
    border: "none",
    padding: "8px",
    borderRadius: "6px",
    fontSize: "11px",
    fontWeight: "700",
    cursor: "pointer"
  },

  rejectionText: {
    fontSize: "10px",
    color: "#b91c1c",
    marginTop: "8px"
  },

  bankSection: {
    background: "#f8fafc",
    padding: "20px",
    borderRadius: "16px"
  },

  bankGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px"
  },

  bankValue: {
    fontSize: "14px",
    fontWeight: "600"
  },

  loading: {
    textAlign: "center",
    padding: "100px",
    fontSize: "20px"
  },

  error: {
    background: "#fef2f2",
    color: "#b91c1c",
    padding: "15px",
    borderRadius: "8px",
    marginBottom: "20px"
  }
};

export default PendingDrivers;